(() => {
  const update = (elem) => {
    elem.style.display = window.swinger.user.isLoggedIn() ? '' : 'none';
  };

  window.swinger.observer.initialize('.swinger-recommendations--auth-required', (elem) => {
    document.addEventListener('swinger.user:authchange', () => {
      update(elem);
    });

    update(elem);
  }, false);
})();
